import type { IconData } from '@stacksjs/iconify-core'

export const ellipsis: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M371 229q0 29-20 49t-50 20t-49-20t-20-49t20-50t49-20t50 20t20 50m-232 0q0 29-20 49t-50 20t-49-20t-20-49t20-50t49-20t50 20t20 50m463 0q0 29-20 49t-49 20t-49-20t-21-49t21-50t49-20t49 20t20 50\"/>",
  "width": 610,
  "height": 700,
  "viewBox": "0 0 610 700"
}

export default ellipsis
